import { generateRequest } from '.';

export const Action = {
  Page: {
    PagePending: 'Page_PENDING',
    PageCompleted: 'Page_FULFILLED',
    PageFailed: 'Page_FAILED',
  },
};

export const fetchPage = url => generateRequest({
  endpoint: `/assets-v2/api/pages/${url}`,
  types: [
    Action.Page.PagePending,
    Action.Page.PageCompleted,
    Action.Page.PageFailed,
  ],
});
